/**
 * 阴影展示大小
 */
export const SHADOW_SIZE = 0.25;

/**
 * Vector SVG preview 与核心渲染链路之间的事件。
 */
export const Events = {
    /**
     * 请求可选 SVG Preview 插件开始、刷新或提交一次连续预览会话。
     *
     * 发送方为 Vector Layer API、Behavior 或 Text Editor；接收方为 VectorLayerSVGPreviewPlugin。
     * 参数为 SVGPreviewRequest，包含 phase 和目标 layer。
     */
    SVGPreviewRequest: 'vector-layer/svg-preview-request',
    /**
     * 通知 Vector Layer 宿主 SVG Preview 的接管状态已经变化。
     *
     * 发送方为 VectorLayerSVGPreviewPlugin，接收方为对应 layerId 的 EdgelessVectorLayer。
     * 参数依次为 layerId 和 active；true 仅在完整组合 Preview 已建立后发送，false 在 Preview 释放时发送。
     */
    SVGPreviewActiveChange: 'vector-layer/svg-preview-active-change',
    /**
     * 通知 SVG Preview 插件最新正式 drawable 已通过版本校验并完成交接。
     *
     * 发送方为 EdgelessVectorLayer，接收方为 VectorLayerSVGPreviewPlugin。参数依次为 layerId 和 ready；
     * ready 为 false 表示正式资源构建失败，插件释放 Preview 后需要恢复旧 Canvas 画面。
     */
    DrawableSettled: 'vector-layer/drawable-settled',
} as const;
